export const API_S3 = 'https://educacione-api.s3.sa-east-1.amazonaws.com';
